import type { Variants } from 'framer-motion';

import type { VariantsTransitionOptions } from './transition';

// ----------------------------------------------------------------------

export const varContainer = (props?: VariantsTransitionOptions): Variants => ({
  animate: {
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.05,
      ...props?.transitionIn,
    },
  },
  exit: {
    transition: {
      staggerChildren: 0.05,
      staggerDirection: -1,
      ...props?.transitionOut,
    },
  },
});
